// extracted by mini-css-extract-plugin
module.exports = {"ToggleSwitch":"ToggleSwitch_ToggleSwitch_1bc6J","disabled":"ToggleSwitch_disabled_d96O7","slider":"ToggleSwitch_slider_SiVjv","checked":"ToggleSwitch_checked_3gkdo"};